import axios from 'axios';
import jwtDecode from 'jwt-decode';

import {configHeaders} from '../utils/configHeaders';

export const login = async (email, password, dispatch) => {
  try {
    dispatch({type: 'LOGIN_START'});
    const {data} = await axios.post(`${process.env.REACT_APP_SERVER_URL}/api/auth`, {
      email,
      password,
    });

    localStorage.setItem('token', data);
    const decodedToken = jwtDecode(data);

    dispatch({type: 'LOGIN', payload: decodedToken.user});

    return decodedToken;
  } catch (error) {
    dispatch({type: 'LOGIN_END'});
    return {error: error.response.data};
  }
};

export const resetPassword = async (resetToken, email, password) => {
  try {
    const {data} = await axios.put(
      `${process.env.REACT_APP_SERVER_URL}/api/auth/passwordreset/${resetToken}`,
      {
        email,
        password,
      }
    );

    return {data: data};
  } catch (error) {
    return {error: error.response.data};
  }
};

export const forgottenPassword = async (email) => {
  try {
    const {data} = await axios.put(
      `${process.env.REACT_APP_SERVER_URL}/api/auth/forgottenpassword`,
      {
        email,
      }
    );

    return {data: data};
  } catch (error) {
    return {error: error.response.data};
  }
};

export const modifyPassword = async (id, oldPassword, password) => {
  try {
    const {data} = await axios.put(
      `${process.env.REACT_APP_SERVER_URL}/api/auth/modifypassword/${id}`,
      {
        oldPassword,
        password,
      },
      await configHeaders()
    );

    return {data: data};
  } catch (error) {
    return {error: error.response.data};
  }
};
